export function log(...args: any[]) {
	console.log(...args);
}
